import React, { useEffect, useState } from 'react'
import useRefreshToken from '../../../../Hooks/usegenerateToken'
import { BASE_URL, EXPORT_ISSUER_DOCUMENT_DATA, EXPORT_REQUESTS, GET_APPEALS, USER_TOKEN } from '../../../../Utils/constant'
import { useSelector } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom'
import SlideUpWrapper from '../../../../components/Transitions/SlideUpWrapper'
import TopTitleBar from '../TopTitleBar'
import style from "../../../DashBoard/CompanyProfile.module.css"
import CustomDropDown from '../../../../components/CustomDropDown'
import Loader from '../../../../components/Loader'
import ShimmerLoader from '../../../../components/ShimmerLoader'
import PageSizeSelector from '../../../../Utils/PageSizeSelector'


import API from "../../../../ApiConfig"
import { _ToNormal, convertDateFormat, parseBlobError, setDate } from '../../../../Utils/helper'
import Icon from 'react-icons-kit'
import { download } from 'react-icons-kit/fa'
import cogoToast from 'cogo-toast-react-17-fix'
import AnimatedLoader from '../../../../components/AnimationLoader'
const RecordsReports = () => {
    useRefreshToken(BASE_URL + USER_TOKEN)

    const[loading, setLoading]=useState(false)
const [search, setSearch]=useState("")

const User=useSelector(state=>state.User)
const [currentAppeals, setCurrentAppeals]=useState([])
const [currentPage, setCurrentPage]=useState(1)
const [totalPages, setTotalPages]=useState(1)
const navigate=useNavigate();
const[pageSize, setPageSize]=useState(10)
const AppealStatus = [
  "all_appeals", "pending_on_issuer", "approved", "denied","issuer_added_different_value"
]
const RequestStatus = [
        "all_requests",
        "completed",
        "pending_on_issuer",
        "pending_on_holder",
        "fnf_pending",
        "recovery_pending",
        "employee_absconding",
        "not_an_employee",
        "active_employee"
  ]
  const DocumentStatus = [
    "draft",
    "published"
]
const [selectedValueRequest, setSelectedValueRequest] = useState("all_requests")
const [selectedValueAppeal, setSelectedValueAppeal] = useState("all_appeals")
const [selectedValue, setSelectedValue]=useState("draft")
  const [dateRange, setDateRange] = useState({ startDate: "", endDate: "" });



const handleDateChange = (field, e) => {
    setDateRange((prev) => ({ ...prev, [field]: e }));
  }
const handleDownloadAppeals = async (e,element) => {
    e.preventDefault();

    setLoading(true);
    if (dateRange.startDate !== "" && dateRange.endDate !== "") {
      const apiData = {
        issuer_company_id: User.company_id,

        // Prefix appeal statuses with "appeals_" so the shared export endpoint
        // filters on the Appeal-status namespace instead of VerificationRequestStatus.
        status: element=="appeals"?`appeals_${selectedValueAppeal}`: selectedValueRequest,
        start_date: convertDateFormat(dateRange.startDate),
        end_date: convertDateFormat(dateRange.endDate),
      };

      API.post(EXPORT_REQUESTS, apiData, { responseType: "blob" })
        .then((res) => {
          if (res.status == 200) {
            const blob = new Blob([res.data], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });

            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");

            link.href = url;
            link.download = `${dateRange.startDate}_to_${dateRange.endDate}.xlsx`;
            document.body.appendChild(link);
            link.click();

            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
          }
        })
        .catch(async (err) => {
                        cogoToast.error(await parseBlobError(err))
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      setLoading(false);
      cogoToast.error("Enter Valid Start and End Date");
    }
  }
  const handleDownloadDocument=(e)=>{
      e.preventDefault()
      setLoading(true);
        if (dateRange.startDate !== "" && dateRange.endDate !== "") {
          const status = selectedValue
          const params = {
            status,
            start_date: convertDateFormat(dateRange.startDate),
            end_date: convertDateFormat(dateRange.endDate),
          }
          // issuer_company_id is required only for super admin; for an issuer the
          // backend derives it from the JWT.
          if (User.user_type == "Super Admin") {
            params.issuer_company_id = id
          }
  API.get(EXPORT_ISSUER_DOCUMENT_DATA, { params, responseType: "blob" })
      .then((res) => {
        if (res.status == 200) {
          const blob = new Blob([res.data], {
          //   type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });

          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");

          link.href = url;
          link.download = `Documents_${status}_${dateRange.startDate}_to_${dateRange.endDate}.xlsx`;
          document.body.appendChild(link);
          link.click();

          document.body.removeChild(link);
          window.URL.revokeObjectURL(url)
}
          }
          )
          .catch(async (err) => {
                    cogoToast.error(await parseBlobError(err));
                  })
                  .finally(() => {
                    setLoading(false);
                  });
              } else {
                setLoading(false);
                cogoToast.error("Enter Valid Start and End Date");
              }
  }
  return (
    <>
     <SlideUpWrapper>
        <TopTitleBar isChild>
          <h2 className="topTitleBarText">
            <span className="secondaryButton1">Record Reports</span>
          </h2>
        </TopTitleBar>
        <div
                  style={{
                    display: "flex",
                    justifyContent: "left",
                    margin: "10px 0px",
                  }}
                >
                    <input
                          type="date"
                          className={style.datePicker}
                          value={dateRange.startDate}
                          style={{ margin: "10px 25px 0px 25px" }}
                          onChange={(e) => {handleDateChange("startDate", e.target.value);setCurrentPage(1)}}
                        />
                        <input
                          type="date"
                          className={style.datePicker}
                          value={dateRange.endDate}
                          style={{margin:"10px 25px 0px 25px"}}
                          onChange={(e) => {handleDateChange("endDate", e.target.value);setCurrentPage(1)}}
                        /></div>
        <div>
          <AnimatedLoader isOpen={loading} loadingText={"Please Wait..."} />
          <div className="credentials-table">

          <table class="key-value-table">
  <tbody>
    <tr>
      <td class="key">Requests</td>
      <td class="value">
      <CustomDropDown
                              list={RequestStatus}
                              selectedOption={selectedValueRequest}
                              onSelect={(e) => {setSelectedValueRequest(e); setCurrentPage(1)}}
                            />
      </td>
      <td class="value" style={{cursor:"pointer"}} onClick={(e)=>handleDownloadAppeals(e,"requests")}>
                          <Icon icon={download} size={18}/>
      </td>

    </tr>
    <tr>
      <td class="key">Appeals</td>
      <td class="value">
      <CustomDropDown
                              list={AppealStatus}
                              selectedOption={selectedValueAppeal}
                              onSelect={(e) => {setSelectedValueAppeal(e); setCurrentPage(1)}}
                            />
      </td>
      <td class="value" style={{cursor:"pointer"}} onClick={(e)=>handleDownloadAppeals(e,"appeals")}><Icon icon={download} size={18}/></td>
    </tr>
    <tr>
      <td class="key">Documents Data</td>
      <td class="value">
      <CustomDropDown
                              list={DocumentStatus}
                              selectedOption={selectedValue}
                              onSelect={(e) => {setSelectedValue(e); setCurrentPage(1)}}
                            />
      </td>
      <td class="value" style={{cursor:"pointer"}} onClick={(e)=>handleDownloadDocument(e)}><Icon icon={download} size={18}/></td>
    </tr>
    {/* <tr>
      <td class="key">Location</td>
      <td class="value">
      <CustomDropDown
                              list={Status}
                              selectedOption={selectedValue}
                              onSelect={(e) => {setSelectedValue(e); setCurrentPage(1)}}
                            />
      </td>
      <td class="value"><Icon icon={download} size={18}/></td>
    </tr> */}
  </tbody>
</table>
          </div >
          {/* <div style={{ margin: "10px" }}>
             <PageSizeSelector value={pageSize} onChange={handlePageSize}/>
                        <Pagination
                            nPages={totalPages}
                            currentPage={currentPage}
                            setCurrentPage={setCurrentPage}
                            onPageChange={handlePageChange}
                            loading={loading}
                        />
                    </div> */}
        </div>
      </SlideUpWrapper>
    </>
  )
}

export default RecordsReports